import { useContext } from 'react'
import Icon from  '@/components/elements/icons/Icons';
import { ContentListContext } from '@/context/ListPageContext';
import { IconLibrary } from  '@/interfaces/IconLibrary';
import "../../../../css/content/downloadContentReportPanel.scss"
import {LocationService} from "../../../../services/location.service.ts";

const DownloadContentReportPanel = () => {  
    const {downloadContentReportLink} = useContext(ContentListContext);
    if (!downloadContentReportLink) {
       return <></>
    }

    function download() {
        LocationService.setHref(downloadContentReportLink);
    }

    return (
        <>
        <button className="download-report-link" onClick={download} aria-label="Download Content Report">
            <Icon iconName={IconLibrary.FILE_DOWNLOAD} sizeInPx='14' color='var(--thriveGreyDark)'/>
            <span className='report-link-text'>Content Report</span>
        </button>
        </>
    );
}

export default  DownloadContentReportPanel